import React from 'react';

import ReactDOM from 'react-dom/client';

import App from './App';

// 👇 Capture query string before React Router mounts
// const fullQuery = window.location.search;
// if (fullQuery) {
//   sessionStorage.setItem('pendingQuery', fullQuery);
// }
const root = ReactDOM.createRoot(document.querySelector('#root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
